import { render, staticRenderFns } from "./ylfw_list.vue?vue&type=template&id=4225ef90&scoped=true&"
import script from "./ylfw_list.vue?vue&type=script&lang=js&"
export * from "./ylfw_list.vue?vue&type=script&lang=js&"
import style0 from "./ylfw_list.vue?vue&type=style&index=0&id=4225ef90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4225ef90",
  null
  
)

export default component.exports